module.exports = __webpack_public_path__ + "static/media/invision-white-slim.300494e9.png";